import dayjs from 'dayjs'

// 对Date的扩展，将 Date 转化为指定格式的String   
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
// 例子：   
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423   
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18   
function formatDate(date,fmt = 'YYYY-MM-DD HH:mm:ss'){ 
    if( date ){
        return dayjs(date).format(fmt);
    }else{
        return ''
    }
} 
/**
 * 生成指定位数的随机数
 * @returns {string}
 */
function random(n){
    let Num=[];
    for(var i=0;i<n;i++)
    {
        Num.push( Math.floor(Math.random()*10) );
    }
    return Num.join('')
}

/**
 * 一位数字 前面补0
 * @param {*} n 
 */
function formatNumber (n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}
/**
 * 去除空格
 * @param {} str 
 */
function trim(str) {
  return str.replace(/\s*/g,"");
}

/**
 * 数字 显示成 xx万
 */
function wan(value) {
  let num;
  if(value > 9999){//大于9999显示x.xx万
    num=(Math.floor(value/1000)/10) + '万';
  }else if( value < 9999 && value>-9999){
    num=value
  }else if(value<-9999){//小于-9999显示-x.xx万
    num = -(Math.floor(Math.abs(value)/1000)/10)+'万'
  }
  return num;
}
//发布于多少天前
function timeago(d1){

    var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date();   //获取当前时间毫秒
    
    var diffValue = moment(d1).diff( now )/1000*-1
    if(diffValue < 0){
        return "刚刚"
    }
    var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
    var hourC = diffValue/hour;
    var dayC = diffValue/day;
    var weekC = diffValue/week;
    var monthC = diffValue/month;
    let result=''
    if(monthC >= 1){
        result = " " + parseInt(monthC) + "月前"
    }else if(weekC >= 1 && weekC <= 3){
        result = " " + parseInt(weekC) + "周前"
    }else if(dayC >= 1 && dayC <= 6){
        result = " " + parseInt(dayC) + "天前"
    }else if(hourC >= 1 && hourC <= 23){
        result = " " + parseInt(hourC) + "小时前"
    }else if(minC >= 1 && minC <= 59){
        result =" " + parseInt(minC) + "分钟前"
    }else if(diffValue >= 0 && diffValue <= minute){
        result = "刚刚"
    }
    return result;
}

/* 价格分成整数部分、小数部分和qi（图书SPU） */
function priceIntegerDecimal (price, fixed = 2) {
    price = ('' + price)
    // 图书SPU做特殊处理
    const qi = price.indexOf('起') >= 0 ? '起' : ''
    price = price.replace('起', '')
    price = (Number(price) || 0).toFixed(fixed).split('.')
    return { integer:price[0], decimal:`.${price[1]}`, qi }
}

export {formatDate,random,formatNumber,trim,wan,timeago,priceIntegerDecimal}
